import { useSelectedOrganization } from '../../../../../../../shared/hooks/use-organizations';

const ALLOWED_ORG_IDS = new Set(['org_wNLKaiSyl8', 'org_w4wEYx0xZ7']);

const useIsCustomFieldFilterAllowed = () => {
  const currentOrg = useSelectedOrganization();
  return currentOrg?.orgId ? ALLOWED_ORG_IDS.has(currentOrg.orgId) : false;
};

export default useIsCustomFieldFilterAllowed;
